import Vue from 'vue'
import { Carousel, Icon, Drawer, Anchor, BackTop } from 'ant-design-vue'

Vue.component(Carousel.name, Carousel)
Vue.component(Icon.name, Icon)
Vue.component(Drawer.name, Drawer)
Vue.component(Anchor.name, Anchor)
Vue.component(Anchor.Link.name, Anchor.Link)
Vue.component(BackTop.name, BackTop)
